import React from "react";
import {MTPLTarifficationDescription} from "../MtplTarifficationDescription";
import "./MtplVehicleSearchViewStyles.scss";
import {Vehicle} from "../../../../../model/vehicle";
import {VehicleSearchView} from "./VehicleSearchView";

interface MTPLVehicleSearchView {
    onSearchListener: (vehicle: Vehicle) => void
    toManualInputListener: () => void
}

export const MTPLVehicleSearchView = ({
    onSearchListener,
    toManualInputListener,
}: MTPLVehicleSearchView) =>  <VehicleSearchView
        onSearchListener={onSearchListener}
        toManualInputListener={toManualInputListener}
        description={MTPLTarifficationDescription} />